import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

// import AsyncBundle from 'ROOT_SOURCE/base/AsyncBundle'
import NavBar from 'ROOT_SOURCE/components/NavBar'
import FootBar from 'ROOT_SOURCE/components/FootBar'

// import Home from './containers/Home'
import Edu from './containers/Edu'
import InfoDcs from './containers/InfoDcs'
import Notice from './containers/Notice'

import './App.scss'

//1
// const AssetMgmtAsync = () => import(
//     'ROOT_SOURCE/containers/AssetMgmt/' /* webpackChunkName:"AssetMgmt" */
// )
// const AssetMgmt = (props) => (
//     <AsyncBundle load={AssetMgmtAsync}>
//         {(Mod) => (<Mod {...props}/>)}
//     </AsyncBundle>
// )

class App extends React.Component {

    constructor() {
        super()
        this.state = {
            showPage: false,
            isJinRong: false
        }
    }

    componentDidMount() {
        this.setState({
            showPage: true
        })
        if (window.location.host === 'qiangui.58.com') {
            this.setState({
                isJinRong: true
            })
        }
    }

    render() {
        const { showPage, isJinRong } = this.state;

        if(!showPage) {
            return (<div></div>)
        } else {
            return (
                <div className="App">
                    <NavBar isJinRong={isJinRong} />
                    <Switch>
                        <Route exact path="/" component={Notice} />
                        <Route path="/edu" component={Edu} />
                        <Route path="/infodcs" component={InfoDcs} />
                        <Redirect to="/" />
                    </Switch>
                    <FootBar />
                </div>
            )
        }
    }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js